import { useAuthStep } from "@/hooks/useAuthStep";
import { trackEvent } from "@/lib/utils";
import { useEffect, useState } from "react";


const WelcomePage = () => {

    const { step, setAuthStep, uuid, setShowConfetti } = useAuthStep();

    const [countdown, setCountdown] = useState<number>(5);

    useEffect(() => {
        trackEvent("signup_welcome_loaded", { "distinct_id": uuid });
    }, []);

    useEffect(() => {
        if (countdown <= 0) return;
        const timer = setTimeout(() => setCountdown(prev => prev - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown]);

    const handleContinue = () => {
        setShowConfetti(true);
        setAuthStep("quickSettings");
    };

    return (
        <div className="flex-1 flex flex-col h-full px-[30px]">
            <h1 className="text-3xl font-semibold mt-[20px]">Finally, the new <span className="text-gray-400 line-through decoration-[2px]">BetterCanvas</span> BetterCampus!</h1>
            {/*<p className="text-base text-gray-500 mt-[20px]">We spent ours cooking up something amazing for you.</p>*/}
            <p className="text-base text-gray-500 mt-[60px]">What's new?</p>
            <ul className="text-base text-black flex flex-col gap-[10px] font-medium mt-[10px]">
                <li>1. More features than ever <span className="text-gray-500 text-sm">(we hope they actually work)</span></li>
                <li>2. Pro version with extra magic <span className="text-gray-500 text-sm">(totally optional)</span></li>
                <li>3. New name <span className="text-gray-500 text-sm">(Canvas didn't like the old one 😭)</span></li>
            </ul>
            <button
                onClick={handleContinue}
                disabled={countdown > 0}
                style={{
                    "background": countdown > 0
                        ? "#d1d5db"
                        : "linear-gradient(120deg, var(--brand-1), var(--brand-2))"
                }}
                className={`mt-8 rounded-xl font-semibold p-3.5 text-white transition-all duration-200 ${
                    countdown > 0
                        ? "cursor-not-allowed"
                        : "hover:brightness-95 shadow-[0_0_20px_#ff7e5299]"
                }`}
            >
                {countdown > 0 ? "Please Wait..." : "Experience the NEW BetterCampus"}
            </button>
            {countdown > 0 && (
                <p className="text-center text-gray-500 text-sm mt-2">
                    Continue in {countdown} second{countdown !== 1 ? 's' : ''}
                </p>
            )}
        </div>
    )
}

export default WelcomePage;